import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

@Component({
  selector: 'epc-filters-load-error',
  templateUrl: './filters-load-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FiltersLoadErrorComponent {
  @Output()
  public refresh = new EventEmitter();

  public onRefresh(event: Event) {
    event.stopImmediatePropagation();
    this.refresh.emit();
  }
}
